import type { Profile, ResumeUpload } from "@/lib/types"

/**
 * What the CV file pickers accept: Markdown and text, read here, and Word and
 * PDF, sent as they are for the server to read (`documents/extract.py`).
 */
export const CV_ACCEPT =
  ".md,.markdown,.txt,.pdf,.docx,text/plain,text/markdown,application/pdf," +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"

const BINARY = /\.(pdf|docx)$/i

/** btoa takes a string, and a large file spread into one call overflows the stack. */
function toBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let binary = ""
  for (let start = 0; start < bytes.length; start += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(start, start + 0x8000))
  }
  return btoa(binary)
}

/** The upload request for one file: text for Markdown, base64 for Word and PDF. */
export async function cvUploadBody(profile: Profile, file: File): Promise<ResumeUpload> {
  if (BINARY.test(file.name)) {
    return { profile, filename: file.name, contentBase64: toBase64(await file.arrayBuffer()) }
  }
  return { profile, filename: file.name, content: await file.text() }
}
